import React from "react";
import { UsernameStyleInterface } from "src/store/mine_craft/usernameStylesSlice";
import CardText from "../../../../componets/CardText";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { setEditId } from "../../../../store/mine_craft/usernameStylesSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyUsernameStyle } from "../../../../actions/mine_craft/usernameStylesActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import IconText from "../../../../componets/IconText";
import { DollarOutlined } from "@ant-design/icons";
import usePermissions from "../../../../hooks/usePermissions";

interface propsInterface {
  usernameStyle: UsernameStyleInterface;
}

const Card = ({ usernameStyle }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formattedCreatedAt = formattedDate(usernameStyle.created_at);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyUsernameStyle(id));

    if (destroyUsernameStyle.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyUsernameStyle.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const gradientTextStyle = {
    fontFamily: "Ubuntu, sans-serif",
    fontSize: "20px",
    fontWeight: "600",
    background: `linear-gradient(${usernameStyle.text_gradient_angle}deg, ${usernameStyle.text_color_start}, ${usernameStyle.text_color_end})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    WebkitTextStroke: `1px ${usernameStyle.stroke_color_end}`,
    letterSpacing: "-0.9px",
  };

  return (
    <CardText
      placeholder='User Nickname'
      placeholderStyle={gradientTextStyle}
      className={'v-mine_craft-usernameStyles__card'}
      size='medium'
      options={write_minecraft ? [
        <ButtonEdit key={`edit-${usernameStyle.id}`} onClick={() => onClickEdit(usernameStyle.id)} />,
        <ButtonDestroy key={`destroy-${usernameStyle.id}`} onClick={() => onClickDestroy(usernameStyle.id)} />
      ] : []}
      stats={[
        <IconText tooltip='popular' icon={DollarOutlined} text={usernameStyle.coins} />,
      ]}
    >
      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardText>
  )
}

export default Card;
